import { useContext, useState } from 'react';
import { Card, Radio, Timeline, Tag, Row, Col, Pagination, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { CalendarOutlined, CheckCircleFilled, LoadingOutlined, NotificationOutlined, TagsOutlined } from '@ant-design/icons';
import Search from 'antd/lib/input/Search';
import Post from '../../../components/model/posts/Post';
import '../../pages.scss';
import { Synchronized } from '../../../components/design/Synchronized/Synchronized';
import { SCHEDULEDJOB } from '../../../../common/constants/services';
import { PostsHistoricalDrawer } from './PostsHistoricalDrawer';
import moment from 'moment';
import { DrawerContext } from '../../../../store/DrawerContext/DrawerContext';
import SelectPeriod from '../../../components/model/selectMonths/SelectPeriod';
import { PageTitle } from '../../common/PageTitle';
import { PageFilters, PageFilterField } from '../../common/PageFilters';

const GooglePosts = () => {

	const [postLocationsVisible, setPostLocationsVisible] = useState(false);
	const [refreshPosts, setRefreshPosts] = useState(false);
	const { projectGroup } = useAuth();
	const [postsGroupsData, setPostsGroupsData] = useState([]);
	const [postGroupSelected, setPostGroupSelected] = useState();
	const [filterReference, setFilterReference] = useState('periodOpt=LAST_12MONTHS');	
	const [pagination, setPagination] = useState({ current: 1, total: 1 });
	const [nextPag, setNextPag] = useState(1);
	const [lastGroupAccount, setLastGroupAccount] = useState(projectGroup.group);
	const { setLogsDrawer } = useContext(DrawerContext);

	const [filterType, setFilterType] = useState('all');
	
	const { t } = useTranslation();

	useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + '/posts?' +
		`type=${filterType}&${filterReference}&` + (projectGroup.group == lastGroupAccount ? `page=${nextPag}` : 'page=1'), {}, [refreshPosts],
		(data) => {
			setPostsGroupsData(data.postsGroups);			
			setPagination(data.pagination);
			setNextPag(data.pagination.current);
			setLastGroupAccount(projectGroup.group);
		});

	const onRangeChange = (range: any) => {      
		setFilterReference('periodOpt=' + range);
	};

	return (
		<Card className='main-card-content'>			
			
			<div style= {{width:'100%', display:'flex', justifyContent:'space-between'}}>
				<PageTitle
					title={t('dictionary.postsHistory') as string}
					pageInfo='Consulta el historial de publicaciones realizadas en tus fichas independientemente de si se hicieron desde esta plataforma o no. Esta vista es especialmente útil si gestionas múltiples establecimientos, ya que se muestran los posts agrupados por fecha y texto de forma que permite ver las publicaciones de forma global e incluso hacer un borrado masivo en caso de que la publicación no sea correcta.'
					extra={
						<Button type='link' onClick={() => setLogsDrawer(true)}>
							Ver Registro
						</Button>
					}
				/>
			</div>
			<Synchronized service={[SCHEDULEDJOB.GBP_POSTS]}/>	
			
			
			<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, marginBottom: 0 }}>
				<PageFilters>
					<PageFilterField label='Tipo' active={filterType !== 'all'}>
						<Radio.Group size='small' value={filterType} onChange={(obj: any) => { setFilterType(obj.target.value) }}>
							<Radio.Button value="all">{t('dictionary.all.plural.female')}</Radio.Button>
							<Radio.Button value="STANDARD"><NotificationOutlined /> {t('dictionary.novelties')}</Radio.Button>
							<Radio.Button value="OFFER"><TagsOutlined /> {t('dictionary.offers')}</Radio.Button>
							<Radio.Button value="EVENT"><CalendarOutlined /> {t('dictionary.events')}</Radio.Button>
						</Radio.Group>
					</PageFilterField>
					<PageFilterField label='Periodo'>
						<SelectPeriod setSelectedType={onRangeChange} defaultValue='LAST_12MONTHS'/>
					</PageFilterField>
				</PageFilters>
			</div>
			<Row gutter={16} style={{ marginTop: '10px' }}>
				{postsGroupsData.length > 0 &&<>
				<Col span={12}>
					<><b>{t('dictionary.page')} {pagination.current}:</b> {postsGroupsData.length} {t('dictionary.posts').toLowerCase()}</>
				</Col>
				<Col span={12}>
					<Pagination size='small' style={{ float: 'right' }}
						simple defaultPageSize={10} current={pagination.current} total={pagination.total}
						onChange={(page) => { setNextPag(page); } } />
				</Col></>
				}
			</Row>
			<div style={{ margin: '20px 0px 30px 0px' }}>
			{
				postsGroupsData.map((postGroupData: any) => {
					return (
						<div style={{display:'flex', justifyContent:'space-between'}}>							
							<div style={{width:'100%', margin: '20px 50px'}}>
								<Post postGroup={postGroupData} />
							</div>
							<Card bodyStyle={{ background: 'white', borderRadius: '20px', width: '350px', margin:'20px', border:'0.5px silver solid'}} style={{border:'0px transparent'}}>
								<Tag style={{ borderRadius: '20px' }}>{postGroupData.postType}</Tag>
								<div style={{ marginTop: '15px', fontSize: '17px', color:'green' }}><b><CheckCircleFilled/> {moment(postGroupData.createdDate).format('ll')}</b></div>
								<div style={{ color: 'grey', marginTop: '30px' }}>{t('dictionary.publishedOnStores', { length: postGroupData.size })}
									<div style={{ fontWeight: 'bold' }}><a onClick={() => { setPostLocationsVisible(true); setPostGroupSelected(postGroupData) }}>{t('dictionary.viewList').toUpperCase()} {'>>>'}</a></div>
								</div>
							</Card>							
						</div>
					)
				})
			}
			</div>
			<Row gutter={16} style={{ marginBottom: '10px' }}>
				{postsGroupsData.length > 0 && <>
				<Col span={12}>
					<><b>{t('dictionary.page')} {pagination.current}:</b> {postsGroupsData.length} {t('dictionary.posts').toLowerCase()}</>
				</Col>
				<Col span={12}>
					<Pagination size='small' style={{ float: 'right' }}
						simple defaultPageSize={10} current={pagination.current} total={pagination.total}
						onChange={(page) => { setNextPag(page); } } />
				</Col></>}
			</Row>
			{
				postLocationsVisible && (
					<PostsHistoricalDrawer setRefreshPosts={setRefreshPosts} refreshPosts={refreshPosts} postGroup={postGroupSelected} postLocationsVisible={postLocationsVisible} setPostLocationsVisible={setPostLocationsVisible} />
				)}
		</Card>
	)
}

export default GooglePosts;